// @typescript-eslint/no-unsafe-return
export function globalState() {
  if (!globalThis.webmoduleComponents) globalThis.webmoduleComponents = {};
  return globalThis.webmoduleComponents;
}
